export default __webpack_public_path__ + "static/media/teacher_classes.091e410d.svg";